/* eslint-disable react/prop-types */
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { formatMoneyPunto } from "utils/formatters";

const getRows = (data) => {
  const rows = [];
  if (data) {
    data.forEach((item, index) => {
      const detalle = item.pedidoCompraDetalle;
      const unidad = detalle?.requierePack ? detalle.unidadPack : detalle?.unidadNombre || detalle?.materiaPrima?.tipoUnidad?.nombre;
      rows.push({
        index: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {index + 1}
            </SoftTypography>
          </SoftBox>
        ),
        nombre: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {detalle?.nombreCompra || item.materiaPrima?.nombre}
            </SoftTypography>
          </SoftBox>
        ),
        cantidad: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item.cantidad} {unidad}
            </SoftTypography>
          </SoftBox>
        ),
        precio: (
          <SoftBox
            sx={{
              borderRadius: "5px",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color={"primary"}
              fontWeight="bold"
            >
              {item?.precioUnitario ? "$ " + formatMoneyPunto(item.precioUnitario) + (unidad ? ` / ${unidad}` : "") : "-"}
            </SoftTypography>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "index", desc: "nº", align: "center", width: "1%"},
  { name: "nombre", desc: "Nombre producto", align: "left", width: "100%", noOrder: true },
  { name: "cantidad", desc: "Cantidad", align: "center", noOrder: true },
  { name: "precio", desc: "Precio Unitario", align: "center", noOrder: true },
];

export default { columns, getRows };
